import {
    chain,
    PopulateApiParameter as basePopulateApiParameter,
} from "@insite/client-framework/Store/Data/Accounts/Handlers/LoadCurrentAccount";
import { createChainHandler, replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

export const PopulateApiParameter = createChainHandler("PopulateApiParameter", chain, props => {
    basePopulateApiParameter(props as any);
    props.apiParameter.expand = ["approvers", "roles"];
});

replaceInChain(chain, basePopulateApiParameter, PopulateApiParameter);
